import { parseQueryState, removeFalsyObjKey } from '#helper';

/**
 * Build search params
 * @param {string} params - current search params.
 * @param {Array|Object} newParams - new search params.
 * @returns {string} - merged search params
 */

export const getSearchParams = (params, newParams) => {
  let searchParams;

  if (!newParams) {
    return '';
  }

  if (Array.isArray(newParams)) {
    const parsedCurrUrl = parseQueryState(params);
    searchParams = new URLSearchParams({
      ...parsedCurrUrl,
      ...{
        appliance: '',
        project: '',
        warehouse: ''
      }
    });
    const param = {
      appliance: [],
      project: [],
      warehouse: [],
      page: [],
      order: [],
      orderBy: []
    };
    newParams.forEach(el => {
      const { type, value } = el;
      const lowerCaseType = type.toLowerCase();
      if (searchParams.has(lowerCaseType)) {
        param[lowerCaseType].push(value);
        searchParams.set(lowerCaseType, `${param[lowerCaseType].join(',')}`);
      } else {
        searchParams.set(lowerCaseType, value);
      }
    });
  } else {
    searchParams = new URLSearchParams(params);
    const { filterType, value, end, start } = newParams;

    if (filterType && value) {
      searchParams.set(filterType, value);
    }
    if (start && end) {
      searchParams.set('start', start);
      searchParams.set('end', end);
    }
  }

  const currentUrl = parseQueryState(params);
  const newUrl = parseQueryState(searchParams.toString());
  const mergedUrls = { ...currentUrl, ...newUrl };
  const url = new URLSearchParams(removeFalsyObjKey(mergedUrls));

  return `${url.toString()}`;
};
